import { LayoutInputParams, TopHeader } from '@mkp/layout/models';
import {
  claimCompanyTopHeader,
  landingPageTopHeader,
  loggedInUserDefaultTopHeader,
  onboardingTopHeader,
  preAccessPageTopHeader,
  regFlowTopHeader,
  withBackButtonTopHeader,
} from './layout-header.config';
import {
  APPLICATIONS,
  APPLICATIONS_MOBILE_WITH_QUERY,
  BO_CLAIM_COMPANY,
  BOOST_SUCCESS,
  BOOST_VACANCY,
  CLAIM_COMPANY,
  CLAIM_MANAGEMENT_DETAILS_WITH_ID,
  CREATE_INVITE,
  CREATE_VACANCY,
  CREATE_VACANCY_GROUP,
  DESIGN_SYSTEM,
  EDIT_VACANCY_PATTERN,
  EXTEND,
  INCOMPLETE_ONBOARDING,
  INVALID_INVITE,
  LANDING_PAGE,
  MY_USER_PROFILE,
  ONBOARDING,
  PUBLISH_VACANCY_PATTERN,
  PURCHASE_CREDITS,
  PURCHASE_CREDITS_COMPARISON,
  PURCHASE_HISTORY,
  REDEEM_INVITE,
  removeQueryParams,
  SELECT_WORKSPACE,
  urlMatchesAnyPage,
  VACANCY_DETAIL_PATTERN,
  VACANCY_GROUP_FORM,
  VERIFY_IDENTITY,
} from './layout-pages.helpers';

export const getPageHeader = ({ url, isMobile, user }: LayoutInputParams) => {
  const sanitizedUrl = removeQueryParams(url);
  return user
    ? getLoggedInUserHeader(sanitizedUrl, isMobile)
    : getVisitorUserHeader(sanitizedUrl, isMobile);
};

export const getLoggedInUserHeader = (url: string, isMobile: boolean): TopHeader => {
  switch (true) {
    case urlMatchesAnyPage([SELECT_WORKSPACE, INCOMPLETE_ONBOARDING], url):
      return preAccessPageTopHeader(isMobile);
    case urlMatchesAnyPage(PAGES_WITH_BACK_BUTTON, url, [CREATE_INVITE]):
      return withBackButtonTopHeader(isMobile);
    case urlMatchesAnyPage([CLAIM_COMPANY], url, [BO_CLAIM_COMPANY]):
      return claimCompanyTopHeader(isMobile);
    case urlMatchesAnyPage([VERIFY_IDENTITY, REDEEM_INVITE, INVALID_INVITE], url):
      return regFlowTopHeader(isMobile);
    default:
      return loggedInUserDefaultTopHeader(isMobile);
  }
};

export const getVisitorUserHeader = (url: string, isMobile: boolean): TopHeader => {
  switch (true) {
    case urlMatchesAnyPage([LANDING_PAGE], url):
      return landingPageTopHeader(false);
    case urlMatchesAnyPage([ONBOARDING], url, [INCOMPLETE_ONBOARDING]):
      return onboardingTopHeader(isMobile);
    default:
      return regFlowTopHeader(isMobile);
  }
};

const PAGES_WITH_BACK_BUTTON = [
  CREATE_VACANCY,
  CREATE_VACANCY_GROUP,
  EDIT_VACANCY_PATTERN,
  VACANCY_DETAIL_PATTERN,
  PUBLISH_VACANCY_PATTERN,
  BOOST_VACANCY,
  APPLICATIONS,
  APPLICATIONS_MOBILE_WITH_QUERY,
  MY_USER_PROFILE,
  BOOST_SUCCESS,
  PURCHASE_CREDITS,
  EXTEND,
  PURCHASE_CREDITS_COMPARISON,
  CLAIM_MANAGEMENT_DETAILS_WITH_ID,
  PURCHASE_HISTORY,
  VACANCY_GROUP_FORM,
  DESIGN_SYSTEM,
];
